import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import api from 'api';
import { API } from 'common/config-api';

const formatDate = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

const SalesDealer = () => {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 6);

    const [startDate, setStartDate] = useState(formatDate(sevenDaysAgo));
    const [endDate, setEndDate] = useState(formatDate(today));
    const [dealerSales, setDealerSales] = useState([]);

    const fetchData = async () => {
        try {
            const res = await api.get(`${API.BASE_URL}/sales/dealer`, {
                params: { startDate, endDate }
            });
            setDealerSales(res.data || []);
        } catch (err) {
            console.error('딜러 판매 데이터 조회 실패:', err);
        }
    };

    useEffect(() => {
        fetchData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // 차트용: 날짜별 집계 (오름차순)
    const uniqueDates = [...new Set(dealerSales.map(d => d.salesDate))].sort();

    const chartOptions = {
        chart: {
            height: 300,
            type: 'area',
            toolbar: { show: false },
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 800,
                animateGradually: { enabled: true, delay: 150 },
                dynamicAnimation: { enabled: true, speed: 350 }
            }
        },
        markers: { size: 4 },
        colors: ['#4154f1', '#2eca6a', '#ff771d'],
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.3,
                opacityTo: 0.4,
                stops: [0, 90, 100]
            }
        },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 2 },
        xaxis: {
            type: 'category',
            categories: uniqueDates
        },
        tooltip: { x: { format: 'MM/dd' } }
    };

    const chartSeries = [
        {
            name: '판매수량',
            data: uniqueDates.map(date =>
                dealerSales.filter(d => d.salesDate === date)
                           .reduce((sum, d) => sum + d.salesQuantity, 0)
            )
        },
        {
            name: '판매금액',
            data: uniqueDates.map(date =>
                dealerSales.filter(d => d.salesDate === date)
                           .reduce((sum, d) => sum + d.salesAmount, 0)
            )
        },
        {
            name: '주문고객',
            data: uniqueDates.map(date =>
                dealerSales.filter(d => d.salesDate === date)
                           .reduce((sum, d) => sum + d.customerCount, 0)
            )
        }
    ];

    return (
        <>
            <div className="row">
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title">일일 판매 그래프 - 딜러</h5>
                        <Chart
                            options={chartOptions}
                            series={chartSeries}
                            type="area"
                            height={300}
                        />
                    </div>
                </div>
            </div>

            <div className="row">
                <div>
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">일일 판매 목록</h5>

                            <div className="row">
                                <div className="col-sm-3">
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </div>
                                <div className="col-sm-1">~</div>
                                <div className="col-sm-3">
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </div>
                                <div className="col-sm-2">
                                    <button type="button" className="btn btn-primary" onClick={fetchData}>
                                        적용
                                    </button>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px' }}></div>

                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>날짜</th>
                                        <th>딜러명</th>
                                        <th>판매수량</th>
                                        <th>판매금액</th>
                                        <th>주문고객</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dealerSales.length === 0 ? (
                                        <tr>
                                            <td colSpan={5} className="text-center text-muted">데이터가 없습니다.</td>
                                        </tr>
                                    ) : (
                                        dealerSales.map((row, i) => (
                                            <tr key={i}>
                                                <td>{row.salesDate}</td>
                                                <td>{row.dealerNickname}</td>
                                                <td>{row.salesQuantity}</td>
                                                <td>{row.salesAmount?.toLocaleString()}</td>
                                                <td>{row.customerCount}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SalesDealer;
